import React from 'react';
import {useAsync} from 'react-async';
import Item from './test-results/Item';
import {I18N} from '../globals/config';
import styles from './test-results.pcss';
import {ThickboxInteractions, withModal} from './modals/thickbox';
import {getTestResults} from '../api/ajax/test-results';
import {isMobile} from '../helpers/device';

export interface TestResult {
	fixAvailable: boolean;
	label: string;
	message: string;
	result: boolean | null;
	testId: string;
}

interface Props extends ThickboxInteractions {
}

const TestResults = ( {close}: Props ) => {
	const {data, isPending} = useAsync<TestResult[]>( getTestResults );

	return (
		<div className={styles.wrap}>
			{isPending && <div className={styles.loading + ' spinner is-active'} />}
			{data && data.map( ( result: TestResult ) => (
				<Item
					key={result.testId}
					item={result} />
			) )}
			<button className={styles.button + ' button-primary'} onClick={close}>
				{I18N.close}
			</button>
		</div>
	);
};

export default withModal( TestResults, {
	width: 700,
	height: isMobile() ? 545 : 340,
	title: I18N.test_results,
} );
